// src/components/auth/VerifyEmail.js
import React, { useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import "./verifyEmail.css"; // We'll add styling here

const VerifyEmail = () => {
  const [otp, setOtp] = useState("");
  const [isResending, setIsResending] = useState(false);
  const navigate = useNavigate();
  const query = new URLSearchParams(useLocation().search);
  const email = query.get("email");
  const [isverify, setIsVerify]=useState(false)

 const handleVerify = async () => {
  if (!otp.trim()) {
    Swal.fire({
      title: "Enter OTP",
      text: "Please enter the OTP sent to your email.",
      icon: "warning",
      width: "300px",
       confirmButtonColor:"green"
    });
    return;
  }

  setIsVerify(true);

  try {
    const apiBaseUrl = process.env.REACT_APP_SERVER_URL;
    const res = await axios.post(`${apiBaseUrl}/api/auth/verify-email`, {
      email,
      otp,
    });

    if (res.status === 200) {
      setIsVerify(false);
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Email verified successfully!",
        width: "300px",
        confirmButtonColor:"green"
      }).then(() => {
        navigate("/login");
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: res.data.message || "Invalid OTP",
        width: "300px",
         confirmButtonColor:"red"
      }).then(() => {
  setIsVerify(false);
  setOtp(""); // This now runs after the alert closes
})
    }
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: error.response?.data?.message || "Verification failed",
      width: "300px",
       confirmButtonColor:"red"
    });
    setIsVerify(false);
    setOtp("");
  }
};

const handleResend = async () => {
  setIsResending(true);
  try {
    const apiBaseUrl = process.env.REACT_APP_SERVER_URL;
    const res = await axios.post(`${apiBaseUrl}/api/auth/resend-otp`, { email });

    if (res.status === 200) {
      Swal.fire({
        title: "OTP Resent",
        text: "A new OTP has been sent to your email.",
        icon: "success",
        width: "300px",
        confirmButtonColor:"green"
      });
    } else {
      Swal.fire({
        title: "Error",
        text: res.data.message || "Failed to resend OTP",
        icon: "error",
        width: "300px",
      });
    }
  } catch (error) {
    Swal.fire({
      title: "Error",
      text: error.response?.data?.message || "Failed to resend OTP",
      icon: "error",
      width: "300px",
       confirmButtonColor:"red"
    });
  } finally {
    setIsResending(false);
  }
};


  const handleCancel = () => {
    navigate("/login");
  };

  return (
    <div className="verify-container">
      <div className="verify-card">
        <h2>Verify Your Email</h2>
        <p className="verify-subtext">
          An OTP was sent to: <strong>{email}</strong>
        </p>
        <input
          type="text"
          data-cy="otp-input"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          placeholder="Enter OTP"
          className="verify-input"
        />
        <div className="verify-buttons">
          <button className="verify-btn primary" onClick={handleVerify} data-cy="verify-btn">
            {isverify ? "Verifying..." : "Verify"}
          </button>
          <button className="verify-btn outline" onClick={handleResend} disabled={isResending} data-cy="resend-btn">
            {isResending ? "Resending..." : "Resend"}
          </button>
          <button className="verify-btn danger" onClick={handleCancel} data-cy="cancel-btn">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
